var map = {
    "ar-sa": "ar-sa",
    "de-de": "de-de",
    "en-us": "en-us",
    "es-es": "es-es",
    "fr-fr": "fr-fr",
    "it-it": "it-it",
    "ja-jp": "ja-jp",
    "ko-kr": "ko-kr",
    "pt-pt": "pt-pt",
    "ru-ru": "ru-ru",
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw"
};
var i18n = {
    "ar-sa": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'لقد وجدنا <span data-role="error-count">x</span> خطأ/أخطاء في النص أعلاه.',

            'checkEroors': 'تحقق من وجود خطأ/أخطاء',

            'checkNextError': 'تحقق من الخطأ المقبل',

            'enterEnglish': 'الرجاء إدخال الحروف الإنجليزية هنا',

            'errorsRemaining': '<span data-role="error-count">x</span> أخطاء متبقية'

        }
    },
    "de-de": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'In obigem Text haben wir <span data-role="error-count">x</span> Fehler gefunden.',

            'checkEroors': 'Nach Fehler(n) suchen',

            'checkNextError': 'Nächsten Fehler suchen',

            'enterEnglish': 'Die englischen Buchstaben bitte hier eingeben',

            'errorsRemaining': '<span data-role="error-count">x</span> verbleibende Fehler'

        }
    },
    "en-us": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}} entered incorrectly。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}} must not less than {{min}}。',

        'max': '{{display}} must not more than {{max}}。',

        'minlength': '{{display}} characters not less than {{min}}。',

        'maxlength': '{{display}} characters not more than {{max}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'We found <span data-role="error-count">x</span> error(s) in the text above.',

            'checkEroors': 'Check error',

            'checkNextError': 'Check next error',

            'enterEnglish': 'Please enter the english letters here',

            'errorsRemaining': '<span data-role="error-count">x</span> errors remaining'

        }
    },
    "es-es": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'Hemos encontrado <span data-role="error-count">x</span> error (es) en el texto anterior.',

            'checkEroors': 'Comprobar error (es)',

            'checkNextError': 'Comprobar el siguiente error',

            'enterEnglish': 'Por favor, introduce caracteres alfabéticos del inglés aquí',

            'errorsRemaining': '<span data-role="error-count">x</span> errores restantes'

        }
    },
    "fr-fr": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'Nous avons trouvé <span data-role="error-count">x</span> erreur(s) dans le texte ci-dessus.',

            'checkEroors': 'Rechercher les erreurs',

            'checkNextError': 'Rechercher la prochaine erreur',

            'enterEnglish': 'Veuillez entrer les lettres anglaises ici',

            'errorsRemaining': '<span data-role="error-count">x</span> erreurs restantes'

        }
    },
    "it-it": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'Abbiamo trovato <span data-role="error-count">x</span> errore/i, nel testo qui sopra.',

            'checkEroors': 'Verifica la presenza di errori',

            'checkNextError': 'Verifica l\'errore successivo',

            'enterEnglish': 'Per favore inserisci le lettere inglesi qui',

            'errorsRemaining': '<span data-role="error-count">x</span> errori rimanenti'

        }
    },
    "ja-jp": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': '上記の本文に<span data-role="error-count">x</span>箇所の間違いがありました。',

            'checkEroors': '間違いを確認して下さい',

            'checkNextError': '下記の間違いを確認して下さい',

            'enterEnglish': '英字をここに入力して下さい',

            'errorsRemaining': '<span data-role="error-count">x</span>残っているエラー'

        }
    },
    "ko-kr": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': '우리는 위의 본문에서 <span data-role="error-count">x</span>개의 에러를 발견했습니다.',

            'checkEroors': '에러 검사',

            'checkNextError': '다음 에러 검사',

            'enterEnglish': '여기에 영어 단어를 입력하세요',

            'errorsRemaining': '<span data-role="error-count">x</span> 개의 오류 남음'

        }
    },
    "pt-pt": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'Nós encontramos <span data-role="error-count">x</span> erro(s) no texo acima',

            'checkEroors': 'Verifique os erro(s)',

            'checkNextError': 'Verifique o próximo erro',

            'enterEnglish': 'Por favor, digite as cartas em inglês aqui',

            'errorsRemaining': '<span data-role="error-count">x</span> erros restantes'

        }
    },
    "ru-ru": {
        'required': 'Please enter the {{display}}.',

        'email': 'Please enter a valid Email Address.',

        'url': 'Please enter a valid Website.',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': 'Мы обнаружили <span data-role="error-count">x</span> ошибку (ошибки, ошибок) в тексте выше.',

            'checkEroors': 'Проверить ошибку (ошибки)',

            'checkNextError': 'Проверить следующую ошибку',

            'enterEnglish': 'В этом поле используйте буквы английского алфавита',

            'errorsRemaining': 'Осталось <span data-role="error-count">x</span> ошибок'

        }
    },
    "zh-cn": {
        'required': '{{display}}不能为空。',

        'email': '{{display}}的格式不正确。',

        'url': '{{display}}的格式不正确。',

        'number': '{{display}}的格式不正确。',

        'date': '{{display}}的格式不正确。',

        'min': '{{display}}必须大于或者等于{{min}}。',

        'max': '{{display}}必须小于或者等于{{max}}。',

        'minlength': '{{display}}的长度必须大于或等于{{min}}。',

        'maxlength': '{{display}}的长度必须小于或等于{{max}}。',

        'mobile': '请输入正确的{{display}}。',

        'confirmation': '{{display}}的内容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': '在以上文本中找到<span data-role="error-count">x</span>个错误。',

            'checkEroors': '检查错误',

            'checkNextError': '检查下一个错误',

            'enterEnglish': '请在此处输入英文字符',

            'errorsRemaining': '<span data-role="error-count">x</span>个剩余错误'

        }
    },
    "zh-tw": {
        'required': '{{display}}不能為空。',

        'email': '{{display}}的格式不正確。',

        'url': '{{display}}的格式不正確。',

        'number': '{{display}}的格式不正確。',

        'date': '{{display}}的格式不正確。',

        'min': '{{display}}必須大於或者等於{{min}}。',

        'max': '{{display}}必須小於或者等於{{max}}。',

        'minlength': '{{display}}的長度必須大於或等於{{min}}。',

        'maxlength': '{{display}}的長度必須小於或等於{{max}}。',

        'mobile': '請輸入正確的{{display}}。',

        'confirmation': '{{display}}的內容和{{name}}不同。',

        'ruleErrorChar': {

            'foundError': '在以上文本中找到<span data-role="error-count">x</span>個錯誤。',

            'checkEroors': '檢查錯誤',

            'checkNextError': '檢查下一個錯誤',

            'enterEnglish': '請在此處輸入英文字符',

            'errorsRemaining': '<span data-role="error-count">x</span>個剩餘錯誤'

        }
    }
};

function _(locale) {
    var r = i18n[map[locale] || 'en-us'];
    r._ = _;
    return r;
}
try {
    var locale = seajs.data.vars.locale;
} catch (e) {
    var locale = 'en-us';
}
module.exports = _(locale);